<template>
  <span>
    <a href="javascript:;" v-on:click="cancel()">
      <i class="fa fa-long-arrow-left"></i>
      <span>&nbsp; Back</span>
    </a>
  </span>
</template>

<script>

export default {
  methods: {
    cancel() {
      const parentAppFrame = global.top.document.getElementById('VuePageFrame')
      if (parentAppFrame) {
        parentAppFrame.className = 'VuePage'
        global.top.document.body.style.overflow = 'auto'
      }
      window.top.location.href = window.top.location.href.replace('/invoice-scanning', '')
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/_modules/InvoiceScan/Components/back.vue